import collectionReducer from '../collectionReducer';

const apmsReducer = collectionReducer({
    collectionActionName: 'APMS',
    itemActionName: 'APM',
});

function reducer(state, action) {
    const reducedState = apmsReducer(state, action);
    if (
        [
            'APM_STATUS_UPDATE_REQUEST',
            'APM_STATUS_UPDATE_FAILURE',
            'APM_STATUS_UPDATE_SUCCESS',
        ].includes(action.type) &&
        action.actionParams?.apmId
    ) {
        let { status } = reducedState.collection[action.actionParams?.apmId];
        if (['APM_STATUS_UPDATE_REQUEST', 'APM_STATUS_UPDATE_FAILURE'].includes(action.type)) {
            status = { ...status, value: !status.value };
        } else if (action.type === 'APM_STATUS_UPDATE_SUCCESS') {
            status = action.payload;
        }

        return {
            ...reducedState,
            collection: {
                ...reducedState.collection,
                [action.actionParams?.apmId]: {
                    ...reducedState.collection[action.actionParams?.apmId],
                    status,
                },
            },
        };
    }

    return reducedState;
}

export default reducer;
